import { render, staticRenderFns } from "./WikiHomepage.vue?vue&type=template&id=09f36a64&"
import script from "./WikiHomepage.vue?vue&type=script&lang=js&"
export * from "./WikiHomepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports